<template>
  <Header />
  <RouterView />
  <Footer />
</template>
<script lang="ts" setup></script>
